export default {"src":"/_next/static/media/my-favorites.48031210.svg","height":15,"width":17,"blurWidth":0,"blurHeight":0};